import {
  DataTable,
  FormDateRangePicker,
  FormLabel,
  Heading,
  Loader,
  Select,
} from "@/components";
import usePaymentListing from "./useListing";
import {
  Button,
  Input
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { SEARCH_CRITERIA } from "./consts";
import { monthOptions } from "@/lib/utils";
import { Search } from "lucide-react";

const Listing = () => {
  const {
    breadcrumbData,
    columns,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    isDocLoading,
    documentList,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    isDocRefetching,
    form,
    onSubmit,
    requiredFields,
    onClear,
    communityDetail,
    onMonthChange,
    month,
    monthKey,
    isLoadingBillingCategory,
    currentFinanceYear,
    sorting,
    setSorting,
  } = usePaymentListing();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={<span>Billing Log - {communityDetail?.name} <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>}
            breadcrumbData={breadcrumbData}
          />
          {/* {isMobile && <Button className="px-2">+ Add Budget</Button>} */}
        </div>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[10px] mt-[10px]">
              <div className="col-span-2">
                <FormDateRangePicker
                  name={SEARCH_CRITERIA}
                  control={form.control}
                  label="Run Date Range"
                  placeholder="Please select"
                  error={errors[SEARCH_CRITERIA]?.message}
                  isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                />
                <div className="flex items-center justify-end">
                  <Button
                    variant="ghost"
                    type="button"
                    onClick={onClear}
                    className="text-[12px] p-0 m-0"
                  >
                    Clear
                  </Button>
                </div>
              </div>
              <Button type="submit">Search</Button>
            </div>
          </form>
        </FormProvider>
      </div>

      <div className="grid grid-cols-1 gap-[30px] items-center mb-[30px]">
        <div className="flex md:justify-end md:items-end">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          <div className="relative w-full md:w-1/5">
            <FormLabel>Month</FormLabel>
            <Select
              key={monthKey}
              options={monthOptions?.map((data: any) => ({
                value: data?.value?.toString(),
                label: data?.label?.toString(),
              }))}
              value={month?.toString()}
              onChange={onMonthChange}
              className="h-[36px] w-[200px]"
            />
          </div>
        </div>
      </div>

      {/* Responsive Table */}
      {isDocLoading ||
      isDocRefetching ||
      isLoadingBillingCategory ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={documentList?.data || []}
            // setGlobalFilter={setGlobalFilter}
            // globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(documentList?.total / pageSize)}
            totalRecords={documentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default Listing;
